import React from 'react';

export default function PageNotFound() {
    return(<p id="pagenotfound">
        Page Not Found!
    </p>)
}